// modalSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactElement, ReactNode } from 'react';

export type TModal = ReactNode | false

const initialState: any = false;

// Create a slice
const adminModalSlice = createSlice({
    name: 'adminModal',
    initialState,
    reducers: {
        setModal: (state: TModal, action: PayloadAction<TModal>) => {
            return action.payload;
        },
        closeModal: (state: TModal) => {
            return false
        }
    },
});

// Export the actions and reducer
export const { setModal, closeModal } = adminModalSlice.actions;
export default adminModalSlice.reducer;

